import React from "react";
import { useInView } from "react-intersection-observer";

// components
import Carousel from "../../Carousel";

// styles
import * as styles from "./ClinicalResearch.module.css";

const ClinicalResearchComponent = ({ carouselData = [] }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className={styles.whatTwinDoWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.headerSection}>
              <h1 className={styles.mainTitle}>
                Validated by Global Clinical Research
              </h1>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Carousel
              items={carouselData}
              slidesToShow={3}
              slidesToShowTablet={2}
              slidesToShowMobile={1}
              gap={24}
              showDots={true}
              showArrows={true}
              autoPlay={false}
              arrowPosition="bottom-right"
              renderItem={(item, index) => (
                <div className={styles.carouselCard}>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardDescription}>{item.description}</p>
                  {item.journal && (
                    <span className={styles.cardJournal}>{item.journal}</span>
                  )}
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClinicalResearchComponent;
